module.exports = __webpack_public_path__ + "static/media/Hide.c9632015.svg";